export default "__VITE_ASSET__e82126f4__"